import { NoseurObject, Scheme } from "@rivtn/noseur"
import { SetURLSearchParams } from "react-router-dom";

export type URLSearchParamsValue = string | string[] | number | number[] | undefined | null;

export const Utils = {

    BUTTON_LOADING_PROPS: {
        disabled: true,
        rightIcon: "fas fa-spinner fa-pulse"
    },

    updateSearchParams(key: string, value: URLSearchParamsValue, setSearchParams: SetURLSearchParams | URLSearchParams, cb?: Function | undefined) {
        const fun = (prev: URLSearchParams) => {
            if (value === undefined || value === null) {
                prev.delete(key);
            } else if (Array.isArray(value)) {
                prev.delete(key);
                for (const v of value) prev.append(key, `${v}`);
            } else {
                prev.set(key, `${value}`);
            }
            return prev;
        };
        if (setSearchParams instanceof URLSearchParams) fun(setSearchParams);
        else setSearchParams(fun);
        cb && cb();
    },

    normalizeUrlParams(urlSearchParams: URLSearchParams, keyLookupMap: NoseurObject<string> = {}, extraParams: NoseurObject<string | number> = {}, reverseKeyLookupMap: NoseurObject<string> = {}) {
        const params: NoseurObject<any> = {};
        Object.keys(Object.fromEntries(urlSearchParams)).forEach((key: string) => {
            const lookupKey = keyLookupMap[key] ?? key;
            const values = urlSearchParams.getAll(reverseKeyLookupMap[lookupKey] ? lookupKey : key);
            if (values.length) {
                params[reverseKeyLookupMap[lookupKey] ?? lookupKey] = values.length > 1 ? values : values[0];
            }
        });
        Object.keys(extraParams).forEach((key) => params[key] = extraParams[key])
        return params;
    },

    urlParamsToSearch(urlSearchParams: URLSearchParams, only?: string[], includes?: NoseurObject<URLSearchParamsValue>) {
        only && only.length && Object.keys(Object.fromEntries(urlSearchParams)).forEach((key: string) => {
            if (!only.includes(key)) urlSearchParams.delete(key);
        });
        if (includes) {
            Object.keys(includes).forEach((key: string) => Utils.updateSearchParams(key, includes[key], urlSearchParams));
        }
        return urlSearchParams.toString();
    },

    copyToClipboard(text: string, cb: (err?: any) => void) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(() => cb(), (err: any) => cb(err));
            return;
        }
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", text);

        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand("copy");
                cb();
            } catch (ex) {
                cb(ex);
                return prompt("Copy to clipboard: Ctrl+C, Enter", text);
            } finally {
                document.body.removeChild(textarea);
            }
        }
    },

};

export * from "./Encryptor";
export type { Encryptor } from "./Encryptor";
export { CacheManager } from "./CacheManager";
export const Schemes: {
    RIVTN_INTERNAL_LOCATIONS: Scheme;
} = {
    RIVTN_INTERNAL_LOCATIONS: "rivtn-internal-locations" as Scheme
}
